import React from 'react';

/**
 * Shared contextual help trigger — same outline "?" control used by
 * Advanced Filters help (filters-ui.css `.filter-help-btn`).
 */
function ContextHelpButton({
  onClick,
  title = 'Help',
  'aria-label': ariaLabel,
  className = '',
  ...rest
}) {
  return (
    <button
      type="button"
      className={`filter-help-btn${className ? ` ${className}` : ''}`}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel || title}
      {...rest}
    >
      <svg
        className="filter-help-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    </button>
  );
}

export default ContextHelpButton;
